// extracted by mini-css-extract-plugin
export default {"childCard":"BoxCard_childCard__MiJdX","card":"BoxCard_card__Ql5ej","defaultBtn":"BoxCard_defaultBtn__kjXb7","badge":"BoxCard_badge__bK2L4"};